/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { api } from 'services/api';
import { notificationContainer } from 'utils/notificationContainer';
import { PayloadAction } from '@reduxjs/toolkit';
import {
	TSwissPostConnectedEmsResponsePayload,
	TSwissPostConnectedEmsRequestPayload,
	TSwissPostAvailableEmsResponsePayload,
	TSwissPostConnectedEmsResponse,
	TSwissPostCreateRequestPayload,
} from './types';
import {
	getSwissPostConnectedEmsRequest,
	getSwissPostConnectedEmsSuccess,
	getSwissPostAvailableEmsRequest,
	getSwissPostAvailableEmsSuccess,
	createSwissPostRequest,
	createSwissPostSuccess,
	swissPostInitState,
} from './reducer';

export function* getSwissPostConnectedEmsWorker(
	action: PayloadAction<TSwissPostConnectedEmsRequestPayload>,
) {
	const { payload } = action;
	try {
		const response: TSwissPostConnectedEmsResponsePayload = yield call(
			api.swissPost.getConnectedEms,
			payload,
		);
		yield put(getSwissPostConnectedEmsSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		yield put(swissPostInitState());
	}
}

export function* getSwissPostAvailableEmsWorker() {
	try {
		const response: TSwissPostAvailableEmsResponsePayload = yield call(
			api.swissPost.getAvailableEms,
		);
		yield put(getSwissPostAvailableEmsSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		yield put(swissPostInitState());
	}
}

export function* createSwissPostWorker(action: PayloadAction<TSwissPostCreateRequestPayload>) {
	const { payload } = action;
	try {
		yield call(api.swissPost.createSwissPost, payload.body);
		yield put(createSwissPostSuccess());
		notificationContainer(
			`Swiss Post successfully ${payload.body.emId ? 'updated' : 'created'}`,
			'success',
		);
		yield put(getSwissPostConnectedEmsRequest(payload.request));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		yield put(swissPostInitState());
	}
}

export function* swissPostSaga() {
	yield takeEvery(getSwissPostConnectedEmsRequest.type, getSwissPostConnectedEmsWorker);
	yield takeEvery(getSwissPostAvailableEmsRequest.type, getSwissPostAvailableEmsWorker);
	yield takeEvery(createSwissPostRequest.type, createSwissPostWorker);
}
